import { Component, Input } from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-activities',
  styleUrls: ['./activities.component.scss'],
  templateUrl: './activities.component.html'
})
export class ActivitiesComponent{

  @Input() public days: any;
  @Input() public hiddenCategories: string[] = [];
  @Input() public showOptionlServices: any;
  @Input() public version: any;
  @Input() public noImageUrl: any;
  @Input() public defaultImage: any;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public serviceIcons: any;

  /** true se il giorno ha almeno una activity non in blacklist (main o suggested). */
  public hasVisibleOptionals(day: any): boolean {
    if (!this.hiddenCategories?.length) {
      return true;
    }

    const groups = [...(day?.optionals || []), ...(day?.optionalsSuggested || [])];

    return groups.some((group: any) =>
      (group?.optionals || []).some((optional: any) => !this.hiddenCategories.includes(optional?.category)));
  }

}
